export const SET_CHART_TYPE = 'SET_CHART_TYPE';
export const SET_SHOW_OVER_TIME_RUNNING_SUM = 'SET_SHOW_OVER_TIME_RUNNING_SUM';
